import type { QueryResponse } from '~/app/_repositories/query-types';
import { convertIErrorResponseToAppError } from '~/infra/api/error-handler';
import { AppError } from '~/models/app-error';
import { ErrorType } from '~/models/app-error';

export const convertToNovelScript = (
  response: QueryResponse,
  isTrial: boolean
): string => {
  const error = response?.response_list[0]?.error;

  if (error) {
    throw convertIErrorResponseToAppError(error);
  }

  const storyResponse = response?.response_list[0]?.story;
  const tellerScript = isTrial
    ? storyResponse?.novel_script?.trial_html_body_script
    : storyResponse?.novel_script?.full_html_body_script;

  if (!tellerScript) {
    throw new AppError(ErrorType.API_REQUEST_404, 'non public', 404, undefined);
  }

  return tellerScript;
};
